export default {
    init: function( $element ) {
        "use strict";
        var _this = this;

        _this.$searchBar = $element.find('.search-bar');
        _this.$searchBtn = $element.find('.js-search');

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this;

        //Search button click event
        _this.$searchBtn.on('click', function () {
            _this.showSearchBar();
        });

        //Close search click event
        _this.$searchBar.find('.close-search').on('click', function () {
            _this.hideSearchBar();
        });

        //ESC key on pressed
        _this.$searchBar.find('input[type="text"]').on('keyup', function (e) {
            if (e.keyCode == 27) {
                _this.hideSearchBar();
            }
        });
    },

    showSearchBar: function () {
        "use strict";
        var _this = this;

        _this.$searchBar.addClass('open');
        _this.$searchBar.find('input[type="text"]').focus();
    },

    hideSearchBar: function () {
        "use strict";
        var _this = this;

        _this.$searchBar.removeClass('open');
        _this.$searchBar.find('input[type="text"]').val('');
    }
};
